import { formatINR } from "@/utils/goldSilverParser";

export function buildGoldFaqs(cityName, currentRates) {
    const g14_1g = formatINR(currentRates?.oneGram?.carat14);
    const g22_1g = formatINR(currentRates?.oneGram?.carat22);
    const g24_1g = formatINR(currentRates?.oneGram?.carat24);
    const g20_1g = formatINR(Math.round((currentRates?.oneGram?.carat24 || 0) * 20 / 24));
    const g18_1g = formatINR(currentRates?.oneGram?.carat18);
    const g14_10g = formatINR(currentRates?.tenGram?.carat14);
    const g22_10g = formatINR(currentRates?.tenGram?.carat22);
    const g24_10g = formatINR(currentRates?.tenGram?.carat24);
    const g20_10g = formatINR(Math.round((currentRates?.tenGram?.carat24 || 0) * 20 / 24));
    const g18_10g = formatINR(currentRates?.tenGram?.carat18);

    return [
        // {
        //     q: `${cityName} में 14 कैरेट सोने का भाव कितना है?`,
        //     a: ` ${cityName} में आज 14 कैरेट सोने का भाव ${g14_1g} प्रति ग्राम और ${g14_10g} प्रति 10 ग्राम है.`
        // },
        {
            q: `${cityName} में आज सोने की कीमत क्या है?`,
            a: `${cityName} में आज 24 कैरेट सोने का भाव ${g24_1g} प्रति ग्राम और 22 कैरेट सोने का भाव ${g22_1g} प्रति ग्राम है. वहीं  18 कैरेट सोना ${g18_1g} प्रति ग्राम पर उपलब्ध है.`,
        },
        {
            q: `${cityName} में 24 कैरेट सोने की कीमत कितनी है?`,
            a: `${cityName} में आज 24 कैरेट सोने का रेट ${g24_1g} प्रति ग्राम और ${g24_10g} प्रति 10 ग्राम है.`,
        },
        {
            q: `${cityName} में 22 कैरेट सोने का रेट क्या है?`,
            a: `${cityName} में आज 22 कैरेट सोने की कीमत ${g22_1g} प्रति ग्राम और ${g22_10g} प्रति 10 ग्राम है.`,
        },


        {
            q: `${cityName} में 20 कैरेट सोने का भाव कितना है?`,
            a: `${cityName} में आज 20 कैरेट सोने का रेट ${g20_1g} प्रति ग्राम और ${g20_10g} प्रति 10 ग्राम है.`,
        },
        {
            q: `${cityName} में 18 कैरेट सोने का क्या रेट है?`,
            a: `${cityName} में आज 18 कैरेट सोने रेट ${g18_1g} प्रति ग्राम और ${g18_10g} प्रति 10 ग्राम है.`,
        },
        {
            q: `क्या ${cityName} और अन्य शहरों में सोने के भाव अलग होते हैं?`,
            a: `${cityName} में आज 22 कैरेट सोना ${g22_1g} प्रति ग्राम है. अलग-अलग शहरों में स्थानीय मांग, ट्रांसपोर्टेशन कॉस्ट और ज्वेलर्स के मार्जिन के कारण कीमतों में मामूली अंतर हो सकता है.`,
        },
        {
            q: `क्या सोने की कीमतें रोज बदलती है?`,
            a: `आज ${cityName} में 24 कैरेट सोना ${g24_1g} प्रति ग्राम है. सोने की कीमत अंतरराष्ट्रीय बाजार, डॉलर इंडेक्स, मांग और आपूर्ति के कारण प्रतिदिन बदलती रहती हैं.`,
        },
        {
            q: `BIS हॉलमार्क क्या होता है?`,
            a: `BIS हॉलमार्क सोने की शुद्धता का सरकारी प्रमाणन है. ${g22_1g} प्रति ग्राम के भाव पर सोना खरीदते समय BIS हॉलमार्क अवश्य जांचें.`,
        },
        {
            q: `सोने पर कितना GST लगता है?`,
            a: `भारत में सोने की खरीद पर 3% GST और मेकिंग चार्ज पर 5% GST लगाया जाता है. यह टैक्स ${g22_10g} के मूल सोना की कीमत के अतिरिक्त होता है.`,
        },
        {
            q: `22K और 24K में क्या अंतर है?`,
            a: `22K सोना 91.6% शुद्ध होता है जबकि 24K सोना 99.9% शुद्ध होता है. आज ${cityName} में 22K सोना ${g22_1g} और 24K सोना ${g24_1g} प्रति ग्राम है.`,
        },
        {
            q: `ज्वैलरी के लिए कौन सा सोना बेहतर है?`,
            a: `ज्यादातर ज्वैलरी 22 कैरेट गोल्ड से बनाई जाती है. हालांकि लोग 18 कैरेट में ज्वैलरी पसंद करते हैं. ${cityName} में आज 22K गोल्ड का रेट ${g22_1g} प्रति ग्राम है.`,
        },
        {
            q: `डिजिटल गोल्ड क्या होता है?`,
            a: `डिजिटल गोल्ड में आप 1 रुपए से भी इन्वेस्ट कर सकते हैं. इसका मूल्य ${cityName} के मौजूदा सोना भाव जैसे ${g24_1g} रुपए प्रति ग्राम के आधार पर तय होता है.`,
        },
        {
            q: `क्या सोना निवेश के लिए बेहतर ऑप्शन है?`,
            a: `सोना लंबे समय के निवेश के लिए ऑल टाइम लोकप्रिय विकल्प है. आज ${cityName} में 24K सोने का भाव ${g24_1g} प्रति ग्राम है.`,
        },
        {
            q: `मेकिंग चार्ज क्या होता है?`,
            a: `ज्वैलरी बनाने की जो लागत होती है मसलन बनाने वाले का मेहनताना वगैरह उसे मेकिंग चार्ज कहते हैं. यह ${g22_10g} के सोने के मूल्य के अतिरिक्त लिया जाता है.`,
        },
        {
            q: `सोने की प्योरिटी की जांच कैसे करें?`,
            a: `BIS हॉलमार्क, HUID नंबर और अधिकृत परीक्षण केंद्रों के माध्यम से सोने की शुद्धता की जांच की जा सकती है.`,
        },
        {
            q: `क्या त्योहारों पर सोना सस्ता मिलता है?`,
            a: `त्योहारों पर ज्वेलर्स मेकिंग चार्ज और रख-रखाव की लागत में भले ही छूट दे दें पर सोने के मूल भाव में छूट नहीं देते हैं.`,
        },
        // {
        //     q: `आज 18 कैरेट सोने का रेट क्या है?`,
        //     a: `आज ${cityName} में 18 कैरेट सोने का रेट ${g18_1g} प्रति ग्राम और ${g18_10g} प्रति 10 ग्राम है.`,
        // },
        // {
        //     q: `आज 20 कैरेट सोने की कीमत क्या है?`,
        //     a: `आज ${cityName} में 20 कैरेट सोने का भाव ${g20_1g} प्रति ग्राम और ${g20_10g} प्रति 10 ग्राम है.`,
        // },
        {
            q: `सोना खरीदते समय खास किन बातों का ध्यान रखना चाहिए?`,
            a: `${g22_1g} प्रति ग्राम के मौजूदा भाव पर सोना खरीदते समय BIS हॉलमार्क, बिल, GST और मेकिंग चार्ज जरूर जांचने चाहिए.`,
        },
        {
            q: `क्या सोने का भाव सभी शहरों में एक जैसा होता है ?`,
            a: `ऐसा नहीं है, ${cityName} में आज 24 कैरेट सोना ${g24_1g} प्रति ग्राम है, जबकि अन्य शहरों में भाव इससे थोड़ा ज्यादा या कम हो सकता है. भाव ट्रांसपोर्टेशन की लागत, रखरखाव और स्थानीय जवैलरी बाजार के आधार पर भी तय होती है.`,
        },
        {
            q: `सोने में डील बेहतर हो इसके लिए कब खरीदना ठीक होगा ?`,
            a: `जब सोने की कीमतों में गिरावट आती है या विशेष ऑफर उपलब्ध होते हैं, तब खरीदारी करना फायदेमंद माना जाता है. त्यौहारी सीजन और शादी-ब्याह के सीजन में सोना खरीदने का मन बना रहे हैं तो डील महंगी पड़ सकती है. इसके अलावा दुनिया के दूसरे देशों में उथल-पुथलऔर शेयर बाजार पर गिरावट के दौर में सोना तेजी पकड़ता है. इस वक्त भी सोना सोच-समझकर ही खरीदें. आज का 22K गोल्ड रेट ${g22_1g} प्रति ग्राम है.`,
        },
        {
            q: `क्या 24 कैरेट सोने से ज्वैलरी बनाई जा सकती है ?`,
            a: `24 कैरेट सोना 99.9% शुद्ध होता है. यह बहुत नरम होता है. यानी इससे बनने वाली ज्वैलरी दबकर पिचक सकती है, इसलिए अधिकांश ज्वेलरी 22K या 18K सोने से बनाई जाती है.`,
        },
    ];
}

export function buildSilverFaqs(cityName, currentRates) {
    const s1g = formatINR(currentRates?.oneGram);
    const s10g = formatINR(currentRates?.tenGram);
    const s100g = formatINR(currentRates?.hundredGram);
    const s1kg = formatINR(currentRates?.oneKg);

    return [
        {
            q: `${cityName} में आज चांदी का ताजा रेट क्या है?`,
            a: `ताजा आंकड़ों के मुताबिक ${cityName} में आज 1 किलो चांदी का दाम ${s1kg} और 100 ग्राम चांदी का दाम ${s100g} है, वहीं 10 ग्राम चांदी ${s10g} और 1 ग्राम चांदी ${s1g} प्रति ग्राम के दाम से बिक रही है.`,
        },
        {
            q: `आज 1 किलो चांदी का दाम कितना है?`,
            a: `आज ${cityName} में 1 किलो चांदी का भाव ${s1kg} है.`,
        },
        {
            q: `आज 100 ग्राम चांदी का रेट कितना है?`,
            a: `${cityName} में आज 100 ग्राम चांदी का दाम ${s100g} है. मार्केट अपडेट के हिसाब से रोजाना ताजा दाम बताए जाते है.`,
        },
        {
            q: `क्या ${cityName} और अन्य शहरों में चांदी के भाव अलग होते हैं?`,
            a: `${cityName} में आज 1 किलो चांदी की ताजा कीमत ${s1kg} है. वहीं दूसरे शहरों में लोकल टैक्स, डिमांड और ज्वेलर्स के मार्जिन के कारण दाम में मामूली अंतर हो सकता है.`,
        },
        {
            q: `चांदी के भाव रोज क्यों बदलती है?`,
            a: `आज ${cityName} में चांदी का दाम ${s1kg} प्रति किलोग्राम है. चांदी का भाव अंतरराष्ट्रीय मार्केट, डॉलर-रुपया विनिमय दर, इंडस्ट्रीयल डिमांड, निवेशकों की खरीदारी और वैश्विक आर्थिक परिस्थितियों के कारण प्रतिदिन बदलती रहती है.`,
        },
        {
            q: `क्या है हॉलमार्क सिल्वर?`,
            a: `हॉलमार्क चांदी की शुद्धता की पक्की गारंटी होता है. इसलिए ${s1kg} के मौजूदा दाम पर जब भी चांदी खरीदें, हॉलमार्क जरूर चेक करें.`,
        },
        {
            q: `चांदी पर कुल कितना GST लगता है?`,
            a: `भारत में चांदी खरीदने पर 3% GST लगता है. इसके अलावा, अगर आप चांदी की ज्वेलरी ले रहे हैं, तो उसके मेकिंग चार्ज पर 5% GST अलग से जुड़ता है. यह टैक्स ${s1kg} के बेस प्राइस (मूल भाव) के ऊपर जोड़ा जाता है.`,
        },
        {
            q: `कब खरीदना चाहिए चांदी?`,
            a: `जब बाजार में चांदी सस्ती हो या कोई खास ऑफर चल रहा हो, तब खरीदारी करना फायदेमंद माना जाता है. आज ${cityName} में 1 किलो चांदी का रेट ${s1kg} है.`,
        },
        {
            q: `क्या चांदी में निवेश करना फायदेमंद है?`,
            a: `चांदी में निवेश न सिर्फ आपके पैसों को सुरक्षित रखता है, बल्कि लंबे समय में अच्छा रिटर्न भी दे सकता है. आज ${cityName} में 1 किलो चांदी ${s1kg} के रेट पर मिल रही है.`,
        },
        {
            q: `शुद्ध चांदी की पहचान कैसे करें?`,
            a: `चांदी असली और शुद्ध है या नहीं, इसकी पहचान हॉलमार्क, फाइननेस नंबर (जैसे 999 या 925), HUID कोड और BIS मान्यता प्राप्त जांच केंद्रों (Testing Centres) के जरिए की जा सकती है.`,
        },
        {
            q: `मेकिंग चार्ज (बनावट शुल्क) क्या होता है?`,
            a: `मेकिंग चार्ज वह फीस या लागत है, जो सुनार चांदी से ज्वेलरी या डिजाइन तैयार करने के लिए लेता है. यह चार्ज ${s1kg} के मूल चांदी भाव (Metal Rate) के ऊपर अलग से जोड़ा जाता है.`,
        },
        {
            q: `त्योहारों में चांदी की खरीदारी पर क्या छूट मिलती है?`,
            a: `त्योहारों और खास मौकों पर ज्वेलर्स मेकिंग चार्ज (बनावट शुल्क) में छूट या ऑफर्स देते हैं, जिससे खरीदारी सस्ती पड़ती है. हालांकि, चांदी का मूल भाव (Base Price) बाजार के हिसाब से ही तय होता है. आज ${cityName} में 1 किलो चांदी का रेट ${s1kg} है.`,
        },
        {
            q: `क्या होता है सिल्वर ETF?`,
            a: `सिल्वर ETF एक डिजिटल निवेश विकल्प है, जिसकी मदद से आप बिना भौतिक (फिजिकल) चांदी खरीदे या उसे घर पर रखे चांदी में निवेश कर सकते हैं. इसकी कीमत बाजार में चल रहे चांदी के रेट (जैसे आज का भाव ${s1kg}) के हिसाब से ऊपर-नीचे होती है.`,
        },
        {
            q: `क्या पूरे देश में चांदी की कीमत एक जैसी होती है?`,
            a: `नहीं, शहरों के हिसाब से चांदी के दामों में अंतर आता है. उदाहरण के लिए, ${cityName} में आज 1 किलो चांदी ${s1kg} है, पर स्थानीय मांग, ट्रांसपोर्टेशन और ज्वेलर्स के मार्जिन के कारण दूसरे शहरों में यह कीमत थोड़ी कम या ज्यादा हो सकती है.`,
        },
        {
            q: `चांदी के भाव क्यों घटते और बढ़ते हैं?`,
            a: `चांदी की कीमतों में उतार-चढ़ाव कई कारकों पर निर्भर करता है. मुख्य रूप से अंतरराष्ट्रीय बाजार का रुख, डॉलर के मुकाबले रुपये की चाल, औद्योगिक मांग, निवेशकों की खरीदारी, महंगाई दर और वैश्विक आर्थिक हालात इसके मुख्य कारण हैं. आज ${cityName} में 1 किलो चांदी का ताजा भाव ${s1kg} है.`,
        },
    ];
}
